<!-- NOMÉS ES UN QR QUE ET PORTA A LA PAGINA DE TOTS ELS QRs, UN QR PER CADA ROUTEPART DE LA RUTA -->
<ng-container *ngIf="!uuidQR">
    <div class="block-esquerra">
        <div class="header"></div>
        <div class="nouuid">
            No valid uuid
        </div>
    </div>
</ng-container>
<div class="container">
    <div class="block-esquerra">
        <shared-cmr-qr-component [uuidQR]="uuidQR" [helpResource]="'SHARED.QR.CMR.HELP'"></shared-cmr-qr-component>
    </div>
</div>
<div class="signaturahardman">
    <img class="logoimg" src="/assets/images/HardmanLogoBlanc.png" alt="Hardman logo">
    <a href="https:hardman.app" target="_blank" class="powered">{{'GLOBAL.DESENVOLUPATPER' | translate}}</a>
</div>